// extracted by mini-css-extract-plugin
module.exports = {"label":"MultiTextInput_label__3rPv-","input":"MultiTextInput_input__1ZCAh"};